export enum TariffBundleNames {
  // COMPREHENSIVE
  // Economy Tariffs
  ChiEconomy10 = 'chi-economy-10',
  ChiEconomy50 = 'chi-economy-50',
  // Business Class Tariffs
  ChiBusiness2019Twin10 = 'chi-business2019twin-10',
  ChiBusiness2019Twin25 = 'chi-business2019twin-25',
  ChiBusinessPro20240 = 'chi-businesspro2024-0',
  // First Class Tariffs
  ChiFirst2019Single10 = 'chi-first2019single-10',
  ChiFirst2019Single25 = 'chi-first2019single-25',
  ChiFirst2019Twin10 = 'chi-first2019twin-10',
  ChiFirst2019Twin25 = 'chi-first2019twin-25',
  ChiFirstProPlus20240 = 'chi-firstproplus2024-0',
  // Expat Tariffs
  ChiExpat10 = 'chi-expat-10',
  // Student Tariffs
  ChiStudentFree = 'chi-student-free',
  ChiStudentProtect = 'chi-student-protect',
  ChiStudentSmart = 'chi-student-smart',
  ChiStudentFree24 = 'chi-student-free24',
  ChiStudentProtect24 = 'chi-student-protect24',

  // RESIDUAL
  // Civil servant applicant
  CshiApplicant2023 = 'cshi-applicant-2023',
  CshiApplicantPlus2023 = 'cshi-applicant-plus-2023',
  // Civil servant
  CshiBasic2021 = 'cshi-basic2021',
  CshiComfort2021 = 'cshi-comfort2021',
  CshiPremium2021 = 'cshi-premium2021',

  // TOP-UP
  // Dental
  TudEconomyV2 = 'tud-economy-v2',
  TudEconomyCareV2 = 'tud-economy-care-v2',
  TudEconomyBonusV2 = 'tud-economy-bonus-v2',
  TudEconomyPremiumV2 = 'tud-economy-premium-v2',
  TudBusinessV2 = 'tud-business-v2',
  TudBusinessCareV2 = 'tud-business-care-v2',
  TudBusinessBonusV2 = 'tud-business-bonus-v2',
  TudBusinessPremiumV2 = 'tud-business-premium-v2',
  TudFirstV2 = 'tud-first-v2',
  TudFirstCareV2 = 'tud-first-care-v2',

  // Clinic
  TucEinbett = 'tuc-einbett',
  TucZweibett = 'tuc-zweibett',
  TucTwen = 'tuc-twen'
}

export const tariffBundleMarketingNames = {
  // COMPREHENSIVE
  // Economy Tariffs
  [TariffBundleNames.ChiEconomy10]: 'Premium Economy Class ottonova PC100',
  [TariffBundleNames.ChiEconomy50]: 'Premium Economy Class ottonova PC100',
  // Business Class Tariffs
  [TariffBundleNames.ChiBusiness2019Twin10]: 'Business Class ottonova BC100',
  [TariffBundleNames.ChiBusiness2019Twin25]: 'Business Class ottonova BC100',
  [TariffBundleNames.ChiBusinessPro20240]: 'Business Class Pro', // FEHLT in mdm
  // First Class Tariffs
  [TariffBundleNames.ChiFirst2019Single10]: 'First Class ottonova FC100',
  [TariffBundleNames.ChiFirst2019Single25]: 'First Class ottonova FC100',
  [TariffBundleNames.ChiFirst2019Twin10]: 'First Class ottonova FC100',
  [TariffBundleNames.ChiFirst2019Twin25]: 'First Class ottonova FC100',
  [TariffBundleNames.ChiFirstProPlus20240]: 'First Class Pro+',
  // Expat Tariffs
  [TariffBundleNames.ChiExpat10]: 'First Class Expats',
  // Student Tariffs
  [TariffBundleNames.ChiStudentFree]: 'Study Free',
  [TariffBundleNames.ChiStudentProtect]: 'Study Protect',
  [TariffBundleNames.ChiStudentSmart]: 'Study Smart',
  [TariffBundleNames.ChiStudentFree24]: 'StudiKomfort24 0 SB',
  [TariffBundleNames.ChiStudentProtect24]: 'StudiKomfort24 500 SB',

  // RESIDUAL
  // Civil servant applicant
  [TariffBundleNames.CshiApplicant2023]: 'ExklusivGarant24 (Gen2)',
  [TariffBundleNames.CshiApplicantPlus2023]: 'ExklusivFlex24 (Gen2)',
  // Civil servant
  [TariffBundleNames.CshiBasic2021]: 'Basis24',
  [TariffBundleNames.CshiComfort2021]: 'Komfort24',
  [TariffBundleNames.CshiPremium2021]: 'Premium24',

  // TOP-UP
  // Dental
  [TariffBundleNames.TudEconomyV2]: 'Economy Class ottonova Zahn 70',
  [TariffBundleNames.TudEconomyCareV2]: 'Economy Class ottonova Zahn 70+',
  [TariffBundleNames.TudEconomyBonusV2]: 'Economy Class ottonova Zahn 75',
  [TariffBundleNames.TudEconomyPremiumV2]: 'Economy Class ottonova Zahn 75+',
  [TariffBundleNames.TudBusinessV2]: 'Business Class ottonova Zahn 85',
  [TariffBundleNames.TudBusinessCareV2]: 'Business Class ottonova Zahn 85+',
  [TariffBundleNames.TudBusinessBonusV2]: 'Business Class ottonova Zahn 90',
  [TariffBundleNames.TudBusinessPremiumV2]: 'Business Class ottonova Zahn 90+',
  [TariffBundleNames.TudFirstV2]: 'First Class ottonova Zahn 100',
  [TariffBundleNames.TudFirstCareV2]: 'First Class ottonova Zahn 100+',

  // Clinic
  [TariffBundleNames.TucEinbett]: 'Klinik Einbett',
  [TariffBundleNames.TucZweibett]: 'Klinik Zweibett',
  [TariffBundleNames.TucTwen]: 'Flex'
};
